
const state = {
  artwork_deadline: '',
  booking_deadline: '',
  editorial_deadline: '',
  inspection_deadline: '',
  id: null,
  publication_date: '',
  publication_id: undefined,
  special_deadline: false,
  title: '',
}

export const requiredFields = [
  { key: 'artwork_deadline' },
  { key: 'booking_deadline' },
  { key: 'publication_date' },
  { key: 'publication_id' },
  { key: 'title' },
]

export default state
